define(function(require) {
    var $ = require("jquery");

    function showOnlyMaterialsForYear(year) {
        $('div.materials-box-info-row').hide();

        $('div.materials-box-info-cell.year').each(function (index, element) {
            if (year === element.innerHTML) {
                $(element).parent().show();
            }
        });
    }

    var yearDropdown = $("#yearDropdown");

    if (yearDropdown.length > 0) {
        var activeYear = $("li.active").find("a").text();

        showOnlyMaterialsForYear(activeYear);
    }

    $("li[name='yearListItem']").find("a").click(function(e) {
        e.preventDefault();

        var yearClicked = $(e.target).text().toString();

        showOnlyMaterialsForYear(yearClicked);

        var yearExpanderButton = $("a.materials-box-opener");

        if (yearExpanderButton.attr("aria-expanded") === "true") {
            $(yearExpanderButton).click();
        }

        $("li[name='yearListItem']").removeClass("active");

        $("li[name='yearListItem']").each(function(index, element) {
            if ($(element).text().trim() === yearClicked) {
                $(element).addClass("active");
            }
        });

        $("span#activeYearSpan").text(yearClicked);
    });
});